import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { Link, NavLink } from 'react-router-dom';
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import Tooltip from 'react-simple-tooltip';

import axios from 'axios';
import { ethers } from 'ethers';
import truncateEthAddress from 'truncate-eth-address';
import { useAccount, useConnect } from 'wagmi';

import { useGlobalContext } from '../../AppContext';
import { add_favorite_wallet, remove_favorite_wallet } from '../../utils/apiOperations';
import { notify } from '../../utils/utils';
import { Button } from '../Button';
import { CopyClipboard } from '../CopyClipboard';
import { Loading } from '../Loading';
import { WalletButton } from '../WalletButton';

import './Header.scss';

export const Header = () => {
  const {
    tutorialCount,
    setTutorialCount,
    demoMode,
    tokensMoonriver,
    isMobile,
    favorites,
    setFavorites,
    address,
    setAddress,
    wallets,
    setCustomSearch,
    setPreparing,
    customSearch,
  } = useGlobalContext();
  const { address: account, connector: connectorWagmi } = useAccount();
  const { connectAsync, connectors } = useConnect();
  const [searchValue, setSearchValue] = useState('');
  const [shownSearchValue, setShownSearchValue] = useState('');
  const [error, setError] = useState('');
  const [searchValuePlaceholder, setSearchValuePlaceholder] = useState('');
  const [loading, setLoading] = useState(true);
  const [suggestions, setSuggestions] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [retrieveAddress, setRetrieveAddress] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [favorited, setFavorited] = useState(false);
  const [, setNotifications] = useState({});
  const [messages, setMessages] = useState<any[]>([]);
  const [showShare, setShowShare] = useState(false);
  const [tutorial, setTutorial] = useState<string>('');
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);
  const readMessage = async (id: number): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/messages.php`,
        params: {
          process: 'read',
          id: id,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (response && response.data && response.data.code === 0) {
        await fetchNotifications();
      }
    } catch (error) {}
  };

  const fetchNotifications = async (): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/messages.php`,
        params: {
          process: 'unread',
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      if (response && response.data) {
        setNotifications(response.data.data);
        const tmp: any[] = [];
        Object.keys(response.data.data).map((item: any) => {
          if (response.data.data[item] && response.data.data[item].length > 0) {
            Object.keys(response.data.data[item]).map((i: any) => {
              tmp.push(response.data.data[item][i]);
            });
          }
        });
        setMessages(tmp);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleNotificationsToggle = () => {
    setShowNotifications(!showNotifications);
  };

  const toggleFavoriteWallet = () => {
    setFavorited(!favorited);
  };

  const retrieveRandomWallet = () => {
    ReactGA.event({ category: 'Header', action: 'Search', label: 'Random Wallet Search' });
    //const randomWallet = '0xF5FFF32CF83A1A614e15F25Ce55B0c0A6b5F8F2c';
    const randomWallets = [
      '0xe4bbcbff51e61d0d95fcc5016609ac8354b177c4',
      '0xce90a7949bb78892f159f428d0dc23a8e3584d75',
      '0x991091D5596484f3153aC8707c76Ec79f6D353ED',
      '0x0ed1e02164a2a9fad7a9f9b5b9e71694c3fad7f2',
      '0xff0bd4aa3496739d5667adc10e2b843dfab5712b',
      '0xd6a984153acb6c9e2d788f08c2465a1358bb89a7',
      '0xa0eaf6b0df87132c9a28e450a43c1d906defb60b',
      '0xc6b0562605d35ee710138402b878ffe6f2e23807',
      '0xE21DC18513e3e68a52F9fcDaCfD56948d43a11c6',
      '0xa679c6154b8d4619af9f83f0bf9a13a680e01ecf',
      '0xc4505db8cc490767fa6f4b6f0f2bdd668b357a5d',
      '0x7F90F772d4DAfb54601dfA4D6022F2542a409C98',
      '0xb6aa5a1aa37a4195725cdf1576dc741d359b56bd',
      '0xbea020c3bd417f30de4d6bd05b0ed310ac586cc0',
      '0xc1064e3662b0718357e9050694a3bfeaabede8ab',
      '0xee81a1bc1034b0906b132c98bed477b896b731da',
      '0x0864224f3cc570ab909ebf619f7583ef4a50b826',
      '0x3becf83939f34311b6bee143197872d877501b11',
      '0x58473e9ac681c4424ca74619281ff71801d002d6',
      '0xc86B12d850FdBBF3260a7BAAE862F85857aAdBBa',
      '0x0394451c1238cec1e825229e692aa9e428c107d8',
      '0x31185f782a7c11044566d70dfcf1c8175486f451',
      '0xbbdac7ba85af15420afd1f4aa3313c3535b15cde',
      '0x33560bB4E2c132346980890A04193616359A04Dc',
      '0x1616b4C7cdb4093BeFBCca62F3198993327a8e9e',
    ];
    setCustomSearch(true);
    setAddress('');
    const randomWalletAddress = randomWallets[(Math.random() * randomWallets.length) | 0];
    setTimeout(() => setAddress(randomWalletAddress), 100);
    setSearchValue(randomWalletAddress);
    setSuggestions(false);
  };

  const retrieveSpecialWallet = (add: string) => {
    ReactGA.event({ category: 'Header', action: 'Search', label: 'Regular Search' });
    setCustomSearch(false);
    setSearchValue(add);
    setAddress(add);
    setPreparing(true);
  };

  const handleOnChange = (e: any) => {
    setSearchValue(e.target.value);
    setError('');
  };
  const retrieveData = async () => {
    if (searchValue) {
      if (ethers.utils.isAddress(searchValue)) {
        setCustomSearch(true);
        setAddress('');
        setTimeout(() => setAddress(searchValue), 100);
        setSuggestions(false);
      } else {
        setRetrieveAddress(true);
        const provider = new ethers.providers.CloudflareProvider();
        const fetchedAddress = await provider.resolveName(searchValue);
        if (fetchedAddress && ethers.utils.isAddress(fetchedAddress)) {
          setCustomSearch(true);
          setAddress('');
          setTimeout(() => setAddress(fetchedAddress), 100);
          setSuggestions(false);
        } else {
          setError('Address or ENS is not valid');
        }
        setRetrieveAddress(false);
      }
    } else {
      setSuggestions(false);
    }
  };
  useEffect(() => {
    if (account) {
      fetchNotifications();
      setShowMobileMenu(false);
    }
  }, [account]);

  useEffect(() => {
    if (tokensMoonriver) {
      setLoading(false);
    }
  }, [tokensMoonriver]);

  useEffect(() => {
    if (address && account) {
      if (address === account) {
        setSearchValue('');
      } else {
        setSearchValue(address);
      }
    }
    setSearchValuePlaceholder(isMobile ? 'Address / Contract' : 'Enter a wallet address...');
  }, [address, account]);

  useEffect(() => {
    if (account) {
      setSuggestions(false);
    } else {
      // setSuggestions(true);
    }
  }, [account]);

  useEffect(() => {
    if (isMobile) {
      setShownSearchValue(truncateEthAddress(searchValue));
    } else {
      setShownSearchValue(searchValue);
    }
  }, [searchValue, isMobile]);

  useEffect(() => {
    if (address && !account) {
      localStorage.setItem('lastSearch', address);
    } else if (account) {
      localStorage.removeItem('lastSearch');
    }
  }, [address]);

  useEffect(() => {
    const getWallet = document.location.search.split('?q=')[1];
    const lastSearch = localStorage.getItem('lastSearch');

    if ((lastSearch || getWallet) && !account) {
      setSearchValue(getWallet ? getWallet : lastSearch);
      setCustomSearch(true);
      setAddress(getWallet ? getWallet : lastSearch);
      setPreparing(true);
      setSuggestions(false);
    }
  }, [document.location]);

  const addressChecker = (arr: any, address: string) => {
    return arr.some((el: any) => {
      return el.address === address;
    });
  };

  const walletIdFinder = (arr: any, address: string) => {
    if (
      arr.some((el: any) => {
        return el.address === address;
      })
    ) {
      return arr.filter((el: any) => {
        return el.address === address;
      })[0]['id'];
    } else {
      return 0;
    }
  };

  const showTutorial = (name: string) => {
    if (tutorialCount >= 1 && tutorialCount <= 9) {
    } else {
      setTutorial(name);
    }
  };

  useEffect(() => {
    if (tutorialCount === 6) {
      setTutorial('headerSearch');
      setTimeout(() => {
        setTutorialCount(7);
        if (isMobile) setShowMobileMenu(true);
      }, 1000);
    } else if (tutorialCount === 7) {
      setTutorial('headerNotification');
      setTimeout(() => {
        setTutorial('');
        setTutorialCount(8);
      }, 1000);
    } else if (tutorialCount === 9) {
      if (isMobile)
        setTimeout(() => {
          setShowMobileMenu(false);
        }, 1000);
    }
  }, [tutorialCount]);

  return (
    <>
      {false && <Loading video={true} onClose={() => setLoading(false)} />}
      {loading && <Loading />}
      {suggestions && !account && !isMobile && (
        <div className="bgLayout2" style={{ backgroundImage: 'url(blur2.png)' }} />
      )}
      {suggestions && !account && isMobile && (
        <div className="bgLayout2" style={{ backgroundImage: 'url(blur3.png)' }} />
      )}
      <div className={`header `}>
        <div className="logo-container">
          <div className="logo">
            <div className="logo-square">
              <NavLink to="/">
                <img className="hidden-m" src={`/images/logo-${theme}.svg`} />
                <img className="visible-m" src={`/images/icon-${theme}.svg`}/>
              </NavLink>
              <span className="beta">BETA</span>
            </div>
          </div>
        </div>
        <div
          onClick={() => {
            showTutorial('');
          }}
          style={{ zIndex: showNotifications ? 5 : 6 }}
          className={`search-container ${
            wallets && account && address !== account && customSearch ? 'temporary' : ''
          }`}
        >
          <div className="search">
            <div className="search-button">
              <button className="search-icon" type="submit">
                <img src={`/icons/search-${theme}.svg`} />
              </button>
              <NavLink
                onClick={() => {
                  if (account) {
                    retrieveSpecialWallet(account);
                  }
                }}
                to={{
                  pathname: '/',
                }}
              >
                <button className="close-icon" type="button">
                  <img
                    src="/icons/add.svg"
                    style={{
                      transform: 'rotate(45deg)',
                      height: '30px',
                      width: 'auto',
                      cursor: 'pointer',
                    }}
                  />
                </button>
              </NavLink>
            </div>
            <div className="search-input">
              <div
                className="input-overlay"
                id="headerInputOverlay"
                onClick={() => {
                  setSuggestions(true);
                  showTutorial('');
                }}
              />
              <input
                type="text"
                placeholder={searchValuePlaceholder}
                maxLength={42}
                readOnly={true}
                disabled={suggestions}
                value={shownSearchValue}
                onClick={() => setSuggestions(true)}
                onChange={handleOnChange}
                onFocus={() => window.scrollTo(0, 0)}
              />

              {address && account && searchValue && (
                <Tooltip
                  placement="left"
                  className="tooltip"
                  border="#ff6aff"
                  background="var(--color-background-main)"
                  color="var(--color-text-main)"
                  content={`${
                    favorites && addressChecker(Object.values(favorites.wallets), address)
                      ? 'Remove from'
                      : 'Add to'
                  } Favorites`}
                >
                  <img
                    onClick={() => {
                      if (addressChecker(Object.values(favorites.wallets), address)) {
                        remove_favorite_wallet(
                          walletIdFinder(Object.values(favorites.wallets), address),
                          setFavorites,
                        );
                      } else {
                        add_favorite_wallet(address, address, setFavorites);
                      }
                    }}
                    className={`${
                      favorites &&
                      favorites.wallets &&
                      addressChecker(Object.values(favorites.wallets), address)
                        ? 'active'
                        : ''
                    }`}
                    src={`/icons/star-${
                      favorites &&
                      favorites.wallets &&
                      addressChecker(Object.values(favorites.wallets), address)
                        ? 'filled'
                        : 'empty'
                    }.svg`}
                    alt=""
                  />
                </Tooltip>
              )}

              {(!account || (account && !searchValue)) && (
                <div className="tooltip">
                  <img
                    onClick={() => {
                      notify(
                        !account
                          ? 'You need to connect your wallet to use this feature.'
                          : 'You need to do a custom search to use this feature.',
                      );
                    }}
                    src={`/icons/star-empty-${theme}.svg`}
                    style={{ cursor: 'default !important', opacity: '0.5' }}
                    alt=""
                  />
                </div>
              )}

              {address && (
                <>
                  <img
                    className="share-icon"
                    src={`/icons/share-${theme}.svg`}
                    onClick={() => {
                      setShowShare(!showShare);
                    }}
                    alt=""
                  />
                  <div className={`${showShare ? 'opened' : ''} share-container`}>
                    <TwitterShareButton className="hidden-m" url={document.location.href}>
                      <TwitterIcon size={32} round={true} />
                    </TwitterShareButton>
                    <FacebookShareButton className="hidden-m" url={document.location.href}>
                      <FacebookIcon size={32} round={true} />
                    </FacebookShareButton>
                    <TelegramShareButton url={document.location.href}>
                      <TelegramIcon size={32} round={true} />
                    </TelegramShareButton>
                    <WhatsappShareButton url={document.location.href}>
                      <WhatsappIcon size={32} round={true} />
                    </WhatsappShareButton>
                    {searchValue && <CopyClipboard content={searchValue} />}
                    <span
                      onClick={() => {
                        setShowShare(false);
                      }}
                      className="close"
                    >
                      &times;
                    </span>
                  </div>
                </>
              )}
              {false && searchValue && account && (
                <div className="add-to-favorite" onClick={toggleFavoriteWallet}>
                  {favorited ? (
                    <Tooltip
                      placement="bottom"
                      className="tooltip"
                      border="#ff6aff"
                      background="var(--color-background-main)"
                      color="var(--color-text-main)"
                      content={'Remove this wallet from favorites.'}
                    >
                      <img className="filled-red" src="/icons/star-filled.svg" alt="" />
                    </Tooltip>
                  ) : (
                    <Tooltip
                      placement="bottom"
                      className="tooltip"
                      border="#ff6aff"
                      background="var(--color-background-main)"
                      color="var(--color-text-main)"
                      content={'Add this wallet to favorites.'}
                    >
                      <img className="filled-white" src={`/icons/star-empty-${theme}.svg`} alt="" />
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
            {suggestions && <div className="grayedOut" />}
            {suggestions && (
              <div className={`suggestions-${theme}`}>
                <div className="suggestions-container main-popup">
                  <div className="sponsored">
                    <div className="sponsored-warning">
                      <img src="/images/icon-dark.svg" />
                      Sponsored
                    </div>
                    <div className="binance">
                      <div className="header-part">
                        <img src="/sponsored/binance/binance.png" /> Binance
                      </div>
                      <div className="description-part">
                        Buy Crypto with Fees as Low as 0%
                        <Link target="_blank" to={{ pathname: 'https://www.binance.com' }}>
                          Start Trading
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="search-form center">
                    <div className="search-input">
                      <div
                        className="suggestions-close header-times"
                        onClick={() => setSuggestions(false)}
                      >
                        &times;
                      </div>

                      <input
                        type="text"
                        placeholder={
                          isMobile
                            ? 'Wallet / ENS / NFT Contract'
                            : 'Enter Wallet Address / NFT Contract / ENS Domain'
                        }
                        onChange={handleOnChange}
                      />
                    </div>

                    <div className="search-button">
                      <Button
                        color="three"
                        label="Search"
                        size={isMobile ? 'medium' : 'large'}
                        onClick={retrieveData}
                        disabled={retrieveAddress}
                      />
                      <Button
                        color="six"
                        label="Random Wallet"
                        size="medium"
                        className="visible-m"
                        onClick={retrieveRandomWallet}
                        disabled={retrieveAddress}
                      />
                    </div>
                    {error && (
                      <div className="error-message-container">
                        <img src="/icons/warning-solid.svg" />
                        {error}
                      </div>
                    )}
                    {!isMobile && (
                      <div className="description">
                        Click <strong onClick={retrieveRandomWallet}>here</strong> to retrieve
                        random wallet details.
                      </div>
                    )}
                    {!connectorWagmi && (
                      <div className="wallet-connect-container">
                        <h4>Or you can connect your wallet</h4>
                        <div className="connector-container">
                          {connectors.map(connector => (
                            <button
                              className={`wallet-connect-button ${
                                isMobile &&
                                connector.id === 'metaMask' &&
                                typeof web3 === 'undefined'
                                  ? 'hidden-m'
                                  : connector.id
                              } ${
                                isMobile && connector.id === 'coinbaseWallet'
                                  ? 'hidden-m'
                                  : connector.id
                              }`}
                              disabled={!connector.ready}
                              key={connector.id}
                              onClick={async () => {
                                await connectAsync({ connector });
                                setSuggestions(false);
                              }}
                            >
                              <img
                                width={isMobile ? 48 : 32}
                                height="auto"
                                src={`/icons/${connector.name.replace(' ', '_').toLowerCase()}.svg`}
                              />
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          {demoMode && tutorial === 'headerSearch' && (
            <>
              <div className="demo-details headerSearch">
                <img src="/tutorial/arrow.svg" alt="" />
                <div className="description">
                  You can search any address
                  <br />
                  and see its details in home
                  <br />
                  dashboard
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className={`visible-m mobile-dropdown-container ${showMobileMenu ? 'opened' : ''}`}
          onClick={() => setShowMobileMenu(!showMobileMenu)}
        >
          <img src={`/icons/wallet-${theme}.svg`} className="normal-icon" alt="" />
          <img src={`/icons/cross-${theme}.svg`} className="close-icon" alt="" />
        </div>
        {showMobileMenu && (
          <div
            className="header-grayed-out"
            onClick={() => {
              setShowMobileMenu(false);
            }}
          />
        )}
        {isMobile && (
          <div className={`visible-m show-mobile-menu ${showMobileMenu ? 'opened' : ''}`}>
            <div className="icon-container">
              <div className="notification-icon">
                {!showNotifications && (
                  <img
                    onClick={
                      demoMode
                        ? () => {
                            notify('You need to connect your wallet to use this feature.');
                          }
                        : handleNotificationsToggle
                    }
                    className="normal-icon"
                    src="/icons/notifications.svg"
                    alt=""
                  />
                )}
                {showNotifications && (
                  <>
                    <div
                      className="float-menu-grayed-out"
                      onClick={() => setShowNotifications(false)}
                    />
                    <div className="close-icon">
                      <img onClick={handleNotificationsToggle} src={`/icons/cross-${theme}.svg`} alt="" />
                    </div>
                  </>
                )}

                {showNotifications && (
                  <div className="notifications-container">
                    <div className="notifications-scroll">
                      {messages &&
                        messages.map((item: any, index: number) => {
                          return (
                            <React.Fragment key={index}>
                              <div
                                onClick={() => readMessage(item.id)}
                                id={`notification-item-${item.id}`}
                                className="notification-item"
                              >
                                <img src="/icons/envelope.svg" alt="" />
                                {item.message}
                              </div>
                            </React.Fragment>
                          );
                        })}
                      {messages && messages.length === 0 && (
                        <div className="noresult">There is nothing new here.</div>
                      )}
                    </div>
                  </div>
                )}
                {demoMode && tutorial === 'headerNotification' && (
                  <>
                    <div className="demo-details mobile headerNotification">
                      <img src="/tutorial/arrow.svg" alt="" />
                      <div className="description">Follow your alerts</div>
                    </div>
                  </>
                )}
              </div>

              
          <div>
            <img
              onClick={(): any => {
                document.body.classList.toggle('dark');
                document.body.classList.toggle('light');
              }}
              src="/icons/dark-mode.svg"
              alt=""
            />
          </div>
         
            </div>
            <div className="wallet-button-container">
              <WalletButton />
            </div>
          </div>
        )}
        <div className="icon-container">
          <div className="notification-icon">
            {!showNotifications && (
              <img
                onClick={
                  demoMode
                    ? () => {
                        notify('You need to connect your wallet to use this feature.');
                      }
                    : handleNotificationsToggle
                }
                src="/icons/notifications.svg"
                className="normal-icon"
                alt=""
              />
            )}
            {showNotifications && (
              <>
                <div
                  className="float-menu-grayed-out"
                  onClick={() => setShowNotifications(false)}
                />
                <div className="close-icon">
                  <img onClick={handleNotificationsToggle} src={`/icons/cross-${theme}.svg`} alt="" />
                </div>
              </>
            )}
            {showNotifications && (
              <div className="notifications-container">
                <div className="notifications-scroll">
                  {messages &&
                    messages.map((item: any, index: number) => {
                      return (
                        <React.Fragment key={index}>
                          <div
                            onClick={() => readMessage(item.id)}
                            id={`notification-item-${item.id}`}
                            className="notification-item"
                          >
                            <img src="/icons/envelope.svg" alt="" />
                            {item.message}
                          </div>
                        </React.Fragment>
                      );
                    })}
                  {messages && messages.length === 0 && (
                    <div className="noresult">There is nothing new here.</div>
                  )}
                </div>
              </div>
            )}
            {demoMode && tutorial === 'headerNotification' && (
              <>
                <div className="demo-details headerNotification">
                  <img src="/tutorial/arrow.svg" alt="" />
                  <div className="description">Follow your alerts</div>
                </div>
              </>
            )}
          </div>

          
          <div>
            <img
              onClick={(): any => {
                document.body.classList.toggle('dark');
                document.body.classList.toggle('light');
              }}
              src="/icons/dark-mode.svg"
              alt=""
            />
          </div>
        </div>
        {!isMobile && (
          <div className="wallet-button-container">
            <WalletButton />
          </div>
        )}
      </div>
    </>
  );
};
